import React from 'react';
import { IntercomContextProvider } from './intercom-context-provider';
import { useOperatorIntercomIdentity } from './use-operator-intercom-identity';

/**
 * Operator's Intercom mount point. Computes operator's identity itself and
 * passes it down as a plain value — mirrors SalesPortalIntercomProvider.
 */
export const OperatorIntercomProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const identity = useOperatorIntercomIdentity();

  return (
    <IntercomContextProvider identity={identity}>
      {children}
    </IntercomContextProvider>
  );
};
